/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserQualification
 */
export interface UserQualification {
    /**
     * 
     * @type {boolean}
     * @memberof UserQualification
     */
    readonly user_qualifies: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserQualification
     */
    readonly entry_count: number;
}

/**
 * Check if a given object implements the UserQualification interface.
 */
export function instanceOfUserQualification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_qualifies" in value;
    isInstance = isInstance && "entry_count" in value;

    return isInstance;
}

export function UserQualificationFromJSON(json: any): UserQualification {
    return UserQualificationFromJSONTyped(json, false);
}

export function UserQualificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserQualification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_qualifies': json['user_qualifies'],
        'entry_count': json['entry_count'],
    };
}

export function UserQualificationToJSON(value?: UserQualification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

